module.exports = __webpack_public_path__ + "static/media/35855883_1946531222037472_2945162493384720384_o_editado.a0681c2f.jpg";